// extracted by mini-css-extract-plugin
module.exports = {"userIcon":"UserInfo_userIcon__1_f_M"};